/* tslint:disable */
/* eslint-disable */
/**
 * Business Orchestration layer (BOL) Notifications API
 * Business Orchestration layer (BOL) Notifications API.  This API is used to manage subscriptions and consumers for BOL notifications. 
 *
 * The version of the OpenAPI document: 7.2.1-develop.2
 * Contact: benoit.tiers@logist-x.eu
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ConsumerStatus } from './ConsumerStatus';
import {
    ConsumerStatusFromJSON,
    ConsumerStatusFromJSONTyped,
    ConsumerStatusToJSON,
    ConsumerStatusToJSONTyped,
} from './ConsumerStatus';
import type { ConsumerBatch } from './ConsumerBatch';
import {
    ConsumerBatchFromJSON,
    ConsumerBatchFromJSONTyped,
    ConsumerBatchToJSON,
    ConsumerBatchToJSONTyped,
} from './ConsumerBatch';
import type { ConsumerWebhook } from './ConsumerWebhook';
import {
    ConsumerWebhookFromJSON,
    ConsumerWebhookFromJSONTyped,
    ConsumerWebhookToJSON,
    ConsumerWebhookToJSONTyped,
} from './ConsumerWebhook';
import type { ResumeStrategy } from './ResumeStrategy';
import {
    ResumeStrategyFromJSON,
    ResumeStrategyFromJSONTyped,
    ResumeStrategyToJSON,
    ResumeStrategyToJSONTyped,
} from './ResumeStrategy';

/**
 * Request body for patching an existing consumer.
 * 
 * ## Enabling/Disabling
 * 
 * To disable a consumer, set `status` to `DISABLED`.
 * To enable a consumer, set `status` to `ACTIVE` and optionally provide `resumeStrategy` and `resumeTimestamp`.
 * 
 * ## Resume Strategies
 * 
 * - **CONTINUE** (default): Resume from last committed offset
 * - **LATEST**: Resume from current offset (skip pending messages)
 * - **EARLIEST**: Resume from beginning of retention period
 * - **FROM_TIMESTAMP**: Resume from specified timestamp (requires `resumeTimestamp`)
 * 
 * @export
 * @interface ConsumerPatchRequest
 */
export interface ConsumerPatchRequest {
    /**
     * Display name of the consumer.
     * @type {string}
     * @memberof ConsumerPatchRequest
     */
    name?: string;
    /**
     * 
     * @type {ConsumerStatus}
     * @memberof ConsumerPatchRequest
     */
    status?: ConsumerStatus;
    /**
     * Whether to include the full Logistics Object body in notifications.
     * 
     * This setting only applies to subscriptions with `notificationType: EVENTS`:
     * - When `true`, the notification includes both the event and the LO body.
     * - When `false` (default), only the event is included.
     * 
     * For `UPDATES` and `ACL` subscriptions, this setting is ignored; the LO is always included.
     * 
     * When enabled, the LO is fetched via the admin API (e.g., `GET /admin/{resource-type}/{id}`).
     * 
     * @type {boolean}
     * @memberof ConsumerPatchRequest
     */
    includeLo?: boolean;
    /**
     * 
     * @type {ResumeStrategy}
     * @memberof ConsumerPatchRequest
     */
    resumeStrategy?: ResumeStrategy;
    /**
     * Timestamp from which to resume consumption. Required when resumeStrategy is FROM_TIMESTAMP and status is set to ACTIVE.
     * @type {Date}
     * @memberof ConsumerPatchRequest
     */
    resumeTimestamp?: Date;
    /**
     * 
     * @type {ConsumerBatch}
     * @memberof ConsumerPatchRequest
     */
    batch?: ConsumerBatch;
    /**
     * 
     * @type {ConsumerWebhook}
     * @memberof ConsumerPatchRequest
     */
    webhook?: ConsumerWebhook;
}



/**
 * Check if a given object implements the ConsumerPatchRequest interface.
 */
export function instanceOfConsumerPatchRequest(value: object): value is ConsumerPatchRequest {
    return true;
}

export function ConsumerPatchRequestFromJSON(json: any): ConsumerPatchRequest {
    return ConsumerPatchRequestFromJSONTyped(json, false);
}

export function ConsumerPatchRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ConsumerPatchRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'] == null ? undefined : json['name'],
        'status': json['status'] == null ? undefined : ConsumerStatusFromJSON(json['status']),
        'includeLo': json['includeLo'] == null ? undefined : json['includeLo'],
        'resumeStrategy': json['resumeStrategy'] == null ? undefined : ResumeStrategyFromJSON(json['resumeStrategy']),
        'resumeTimestamp': json['resumeTimestamp'] == null ? undefined : (new Date(json['resumeTimestamp'])),
        'batch': json['batch'] == null ? undefined : ConsumerBatchFromJSON(json['batch']),
        'webhook': json['webhook'] == null ? undefined : ConsumerWebhookFromJSON(json['webhook']),
    };
}

export function ConsumerPatchRequestToJSON(json: any): ConsumerPatchRequest {
    return ConsumerPatchRequestToJSONTyped(json, false);
}

export function ConsumerPatchRequestToJSONTyped(value?: ConsumerPatchRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'status': ConsumerStatusToJSON(value['status']),
        'includeLo': value['includeLo'],
        'resumeStrategy': ResumeStrategyToJSON(value['resumeStrategy']),
        'resumeTimestamp': value['resumeTimestamp'] == null ? value['resumeTimestamp'] : value['resumeTimestamp'].toISOString(),
        'batch': ConsumerBatchToJSON(value['batch']),
        'webhook': ConsumerWebhookToJSON(value['webhook']),
    };
}

